<router-outlet></router-outlet>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/auth/auth.component.ts.AuthComponent.html